export default __webpack_public_path__ + "static/media/woodcut-style-man-moon.921588da.png";